interface IResourcesSearchHistory {
  search: string;
  timestamp: string;
}

const SEARCH_HISTORY_KEY = 'resourcesSearchHistory';

export default function useResourcesSearchHistory() {
  const saveSearch = (search: string) => {
    const searchHistory = localStorage.getItem(SEARCH_HISTORY_KEY);
    if (searchHistory) {
      const searchHistoryArray = JSON.parse(searchHistory);
      const currentDate = new Date();
      const existingSearchWithinDay = searchHistoryArray.find(
        (item: IResourcesSearchHistory) =>
          item.search === search &&
          new Date(item.timestamp).getDate() === currentDate.getDate() &&
          new Date(item.timestamp).getMonth() === currentDate.getMonth() &&
          new Date(item.timestamp).getFullYear() === currentDate.getFullYear()
      );
      if (!existingSearchWithinDay) {
        searchHistoryArray.push({ search, timestamp: new Date().toISOString() });
      } else {
        searchHistoryArray.splice(searchHistoryArray.indexOf(existingSearchWithinDay), 1);
        searchHistoryArray.push({ search, timestamp: new Date().toISOString() });
      }
      localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(searchHistoryArray));
    } else {
      localStorage.setItem(
        SEARCH_HISTORY_KEY,
        JSON.stringify([{ search, timestamp: new Date().toISOString() }])
      );
    }
  };

  const getSearches = (): IResourcesSearchHistory[] => {
    const searchHistory = localStorage.getItem(SEARCH_HISTORY_KEY);
    if (searchHistory) {
      return JSON.parse(searchHistory).sort(
        (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
      );
    }

    return [];
  };

  const clearSearches = () => {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
  };

  return { saveSearch, getSearches, clearSearches };
}
